import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import AddCircle from '@material-ui/icons/AddCircle';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(pure);

const button = enhance(
  ({ classes, params, onClickAction, enabled = false }) => {
    return (
      <Button
        color="primary"
        onClick={() => onClickAction(params)}
        disabled={!enabled}
      >
        <AddCircle className={classes.leftIcon} />
        登録
      </Button>
    );
  }
);

export default withStyles(styles)(button);
